"use strict";import{css as t}from"@spectrum-web-components/base";const a=t`
    #switch:before{transition:background var(--spectrum-animation-duration-100,.13s)ease-in-out,border var(--spectrum-animation-duration-100,.13s)ease-in-out,box-shadow var(--spectrum-animation-duration-100,.13s)ease-in-out}
`;export default a;
//# sourceMappingURL=switch-legacy.css.js.map
